import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation, { type UseMutationOptions } from 'src/hooks/utils/useMutation'

const useDeleteFileMutation = (options?: UseMutationOptions<{ fileId: string }>) => {
  const account = useAccount()

  return useMutation(
    async ({ fileId }) => {
      await api.post(`provide/${account.id}/file/delete`, { id: fileId })
    },
    {
      ...options,
      errorMessage: 'An error occurred while deleting the file.'
    }
  )
}

export default useDeleteFileMutation
